import axios from 'axios';
import {
  helperGetApiHeaders,
  helperGetApiRoute,
  helperConvertApiRoute,
  helperGetLiveUpNextUrl,
  axiosErrorHandler,
} from 'helpers/ApiHelper';

export const FETCH_HEADER_SEARCH = 'FETCH_HEADER_SEARCH';
export const REFRESH_SEARCH_PANEL = 'REFRESH_SEARCH_PANEL';
export const FETCH_NEXT_SEARCH = 'FETCH_NEXT_SEARCH';
export const SET_FETCHING_SEARCH = 'SET_FETCHING_SEARCH';
export const FETCH_UP_NEXT_SEARCH = 'FETCH_UP_NEXT_SEARCH';
export const SET_TAB = 'SET_TAB';
export const RESET_NEXT_PAGE = 'RESET_NEXT_PAGE';
export const RESET = 'RESET';

export function fetchSearch({ accessToken, url, deviceId } = {}) {
  let pageType = 'browse';
  const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });
  const fetchUrl = helperConvertApiRoute(url) || helperGetApiRoute(pageType);

  if (url) pageType = null;
  const request = axios.get(fetchUrl, headers).catch(axiosErrorHandler);

  return {
    type: FETCH_HEADER_SEARCH,
    payload: request,
  };
}

export function fetchNextPage(accessToken, url, pageType, deviceId) {
  if (url && pageType) {
    const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });
    const request = axios.get(helperConvertApiRoute(url), headers).catch(axiosErrorHandler);

    return {
      type: FETCH_NEXT_SEARCH,
      payload: request,
    };
  }
  return { type: FETCH_NEXT_SEARCH };
}

export function refreshSearchPanel(accessToken, url, deviceId) {
  const request = axios
    .get(helperConvertApiRoute(url), helperGetApiHeaders({ accessToken, deviceId }))
    .catch(axiosErrorHandler);

  return {
    type: REFRESH_SEARCH_PANEL,
    payload: request,
  };
}

export function fetchUpNext({ videoId, accessToken, deviceId }) {
  const { url, pageType } = helperGetLiveUpNextUrl({ videoId });
  const request = axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(axiosErrorHandler);

  return {
    type: FETCH_UP_NEXT_SEARCH,
    payload: request,
  };
}

export function setFetching(value) {
  return {
    type: SET_FETCHING_SEARCH,
    payload: value,
  };
}

export function setTab(value, selectedFilterIdx, headline, collectionType) {
  return {
    type: SET_TAB,
    payload: {
      value,
      selectedFilterIdx,
      headline,
      collectionType,
    },
  };
}

export function resetNextPage() {
  return {
    type: RESET_NEXT_PAGE,
    payload: {},
  };
}

export function reset() {
  return {
    type: RESET,
    payload: {},
  };
}
